import React, { Component } from 'react';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';

class JavaScriptInput extends Component {

    state = {
        src: this.props.initialValues.src || '',
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            src: this.state.src,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        if (this.props.isResultInput) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = this.state.src;
            document.body.appendChild(script);
        } else {
            setTimeout(_ => {
                this.updateInputPropsInStore();
            }, 500);
        }
    };

    componentDidUpdate() {
        this.updateInputPropsInStore();
    };

    setSrc = (e) => {
        this.setState({ src: e.target.value });
    };

    render() {
        if (this.props.isResultInput) {
            return null;
        }
        return (
            <AppInputWrapper label="Insert your js code below">
                <textarea
                    rows="10"
                    style={{ width: '100%' }}
                    value={this.state.src}
                    onChange={this.setSrc}
                ></textarea>
            </AppInputWrapper>
        );
    }
}

export default connect(
    () => ({}),
    { editInputWithProps }
)(JavaScriptInput);
